<template>
    <vs-sidebar click-not-close position-right parent="body" default-index="1" color="primary" class="add-new-data-sidebar items-no-padding" spacer v-model="isSidebarActiveLocal">
        <div class="mt-6 flex items-center justify-between px-6">
            <h4>Ajouter une facture</h4>
            <feather-icon icon="XIcon" @click.stop="isSidebarActiveLocal = false, error=[]" class="cursor-pointer"/>
        </div>
        <vs-divider class="mb-0"/>
        <VuePerfectScrollbar class="scroll-area--data-list-add-new" :settings="settings" :key="$vs.rtl">
            <div class="p-6">
                <vs-select
                        :danger="error.customer ? true : false"
                        :danger-text="error.customer ? error.customer[0] : ''"
                        @change="getContract()" v-model="form.customer"
                        autocomplete class="mt-5 w-full" label="Liste des clients"
                >
                    <vs-select-item :key="index" :value="item.id" :text="item.social_reason" v-for="(item,index) in customers" />
                </vs-select>

                <vs-select v-model="form.contract"
                           :danger="error.contract ? true : false"
                           :danger-text="error.contract ? error.contract[0] : ''"
                           autocomplete class="mt-5 w-full"
                           label="Liste des contrats">
                    <vs-select-item :key="index" :value="item.code_contract" :text="item.code_contract" v-for="(item,index) in contracts" />
                </vs-select>

                <vs-input type="number" @change="changeHt"
                          :danger="error.montant_hors_taxe ? true : false"
                          :danger-text="error.montant_hors_taxe ? error.montant_hors_taxe[0] : ''"
                          v-model="form.montant_hors_taxe"
                          class="mt-5 w-full" label="Montant HT en F CFA" />

                <vs-input type="number" @change="changeTaxe"
                          :danger="error.montant_taxe ? true : false"
                          :danger-text="error.montant_taxe ? error.montant_taxe[0] : ''"
                          v-model="form.montant_taxe" class="mt-5 w-full"
                          label="Montant de la Taxe en F CFA" />

                <vs-input type="number" disabled
                          :danger="error.montant_tout_taxe ? true : false"
                          :danger-text="error.montant_tout_taxe ? error.montant_tout_taxe[0] : ''"
                          v-model="form.montant_tout_taxe"
                          class="mt-5 w-full" label="Montant TTCen F CFA"/>

                <vs-input type="date"
                          :danger="error.date_facture ? true : false"
                          :danger-text="error.date_facture ? error.date_facture[0] : ''"
                          v-model="form.date_facture"
                          class="mt-5 w-full" label="Date de Facture"/>

                <vs-input type="date"
                          :danger="error.date_echeance ? true : false"
                          :danger-text="error.date_echeance ? error.date_echeance[0] : ''"
                          v-model="form.date_echeance"
                          class="mt-5 w-full" label="Date d'échéance"/>          
            </div>
        </VuePerfectScrollbar>
        <div class="flex flex-wrap items-center p-6" slot="footer">
            <vs-button @click="createBill" type="border" style="margin-right: 5px" color="success">Enregistrer</vs-button>
            <vs-button type="border" color="danger" @click="isSidebarActiveLocal = false, error = []">Fermer</vs-button>
        </div>
    </vs-sidebar>
</template>

<script>
    import VuePerfectScrollbar from 'vue-perfect-scrollbar';
    export default {
        components: {VuePerfectScrollbar},
        props: {
            isSidebarActive: {
                type: Boolean,
                required: true
            },
            loadBillsEvent:{
                type: Function
            },
            showActions: {
                type: Boolean,
                default: true
            },
            customers:{
                type: Array,
                required: true
            }
        },
        data: () => ({
            settings: { // perfectscrollbar settings
                maxScrollbarLength: 60,
                wheelSpeed: .60,
            },
            error:[],
            form:{
                customer: '',
                contract: '',
                montant_hors_taxe: '',
                montant_taxe: '',
                date_facture: '',
                date_echeance: '',
                montant_tout_taxe: ''
            },
            contracts: []
        }),
        computed: {
            isSidebarActiveLocal: {
                get() {
                    return this.isSidebarActive
                },
                set(val) {
                    if(!val) {
                        this.$emit('closeSidebar')
                    }
                }
            },
        },
        methods: {
            getContract(){
                this.$vs.loading()
                let id = this.form.customer
                this.$http.get('/customers/contracts/'+id).then((response) => {
                    this.contracts = response.data
                    this.$vs.loading.close()
                }).catch((error) =>{
                    this.$vs.loading.close()
                    if (error.response.status === 401){
                        this.$router.push('/login')
                    }
                })
            },
            createBill(){
                this.$vs.loading()
                this.form.upload_id = this.$route.params.id
                let form = this.form
                this.$http.post('/bills/create', {form}).then((response) => {
                    this.$vs.loading.close()
                    if (response.data.status){
                        window.GETCCMT.notification('success','Ajout', 'Opération effectuée')
                        this.isSidebarActiveLocal = false
                        this.loadBillsEvent()
                    }
                }).catch((error) =>{
                    this.$vs.loading.close()
                    if (error.response.status === 401){
                        this.$router.push('/login')
                    }else this.error = error.response.data.errors
                })
            },
            changeHt(){
                if (this.form.montant_hors_taxe !== '' && this.form.montant_taxe !== ''){
                    this.form.montant_tout_taxe = parseInt(this.form.montant_hors_taxe) + parseInt(this.form.montant_taxe)
                }
            },
            changeTaxe(){
                if (this.form.montant_hors_taxe !== '' && this.form.montant_taxe !== ''){
                    this.form.montant_tout_taxe = parseInt(this.form.montant_hors_taxe) + parseInt(this.form.montant_taxe)
                }
            }
        }
    }
</script>

<style lang="scss" scoped>
    .border_bill{
        border-color: #EA5455 !important;
    }
    .add-new-data-sidebar {
        ::v-deep .vs-sidebar--background {
            z-index: 52010;
        }

        ::v-deep .vs-sidebar {
            z-index: 52010;
            width: 400px;
            max-width: 90vw;

            .img-upload {
                margin-top: 2rem;

                .con-img-upload {
                    padding: 0;
                }

                .con-input-upload {
                    width: 100%;
                    margin: 0;
                }
            }
        }
    }

    .scroll-area--data-list-add-new {
        // height: calc(var(--vh, 1vh) * 100 - 4.3rem);
        height: calc(var(--vh, 1vh) * 100 - 16px - 45px - 82px);
    }
</style>